/**
 * Flow Center
 *
 * Central area containing flow progress, context bar, and the active node view.
 * Used in all layout modes (2-team flanking, multi-team, no-teams).
 */

import type { FlowContext, FlowPlayer, NodeState } from "@rivaled/shared";
import { FlowProgress } from "../player/FlowProgress";
import { NodeRenderer } from "../player/NodeRenderer";

type FlowCenterProps = {
  currentNode: NodeState | null;
  players: FlowPlayer[];
  context: FlowContext;
  progress: { completed: number; total: number };
  timeRemaining: number | null;
  isTransitioning?: boolean;
  onAction: (type: string, payload: unknown) => Promise<{ success: boolean; error?: string }>;
};

export function FlowCenter({
  currentNode,
  players,
  context,
  progress,
  timeRemaining,
  isTransitioning,
  onAction,
}: FlowCenterProps) {
  return (
    <div className="flex flex-col gap-3 min-w-0">
      {currentNode && (
        <FlowProgress
          completedNodes={progress.completed}
          totalNodes={progress.total}
          currentNodeName={currentNode.nodeType}
          timeRemaining={timeRemaining}
          isTransitioning={isTransitioning}
          context={context}
          players={players}
        />
      )}

      {currentNode && (
        <NodeRenderer
          nodeState={currentNode}
          players={players}
          context={context}
          onAction={onAction}
        />
      )}
    </div>
  );
}
